const GoogleFormEmbed = () => {
  return (
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSc1pbJM3miCe3ohy0ylmAPylPxCnBMX1hKs6crDmFlbHQFd4g/viewform?usp=publish-editor"
      title="Contact Google Form"
      className="w-full h-full border-0"
      loading="lazy"
    />
  );
};

export default GoogleFormEmbed;
